export type SearchVerticalSlug = "everything-equine" | "horses" | "saddlery-tack-apparel" | "transport-vehicles" | "stallions-at-stud" | "equine-farm-equipment" | "horse-care-products" | "equine-property" | "services" | "giftware-resources";

export interface SearchVerticalOption {
  id: string;
  label: string;
  slug: SearchVerticalSlug;
  level: number;
  isHorses?: boolean;
  hideFromTopNav?: boolean;
}

const VERTICAL_OPTIONS: SearchVerticalOption[] = [
  {
    id: "0",
    label: "Everything Equine",
    slug: "everything-equine",
    level: 0,
    isHorses: true,
    hideFromTopNav: true
  },
  {
    id: "196",
    label: "Horses",
    slug: "horses",
    level: 0,
    isHorses: true,
  },
  {
    id: "198",
    label: "Saddlery, Tack & Apparel",
    slug: "saddlery-tack-apparel",
    level: 0,
  },
  {
    id: "201",
    label: "Transport & Vehicles",
    slug: "transport-vehicles",
    level: 0,
  },
  {
    id: "197",
    label: "Stallions at Stud",
    slug: "stallions-at-stud",
    isHorses: true,
    level: 0,
  },
  {
    id: "202",
    label: "Equine Property",
    slug: "equine-property",
    level: 0,
  },
  {
    id: "services",
    label: "Services",
    slug: "services",
    level: 0,
  },
  {
    id: "199",
    label: "Equine & Farm Equipment",
    slug: "equine-farm-equipment",
    level: 0,
  },
  {
    id: "375",
    label: "Horse Care Products",
    slug: "horse-care-products",
    level: 0,
  },
  {
    id: "204",
    label: "Giftware & Resources",
    slug: "giftware-resources",
    level: 0,
  },
];

export default VERTICAL_OPTIONS;
